import React, { useEffect } from "react";
import { useState } from "react";
import styles from "../../css/plugins.module.css";
import PluginsOptional from "./PluginsOptional";
import PluginsBuiltIn from "./PluginsBuiltIn";

const PluginsMain = ({ plugins, userPlugins, refreshData }) => {
  const [tabItem, setTabItem] = useState(true);
  const [optional, setOptional] = useState([]);
  const [builtin, setBuiltin] = useState([]);

  useEffect(() => {
    const optionalPlugins = plugins?.plugins?.filter(
      (plugin) => plugin.required === 0
    );
    setOptional(optionalPlugins);

    const builtinPlugins = plugins?.plugins?.filter(
      (plugin) => plugin.required === 1
    );
    setBuiltin(builtinPlugins);
  }, [plugins]);

  return (
    <div className={`${styles.pluginsWrapper} container`}>
      <div className={styles.pluginsHead}>
        <h2>Plugins</h2>
        <p>
          Empower your database with optional and built-in Plugins. See the
          options below.
        </p>
      </div>
      <ul className={styles.pluginsNavigate}>
        <li>
          <button
            className={`${tabItem ? styles.active : ""}`}
            onClick={() => setTabItem(true)}
          >
            Optional
          </button>
        </li>
        <li>
          <button
            className={`${tabItem ? "" : styles.active}`}
            onClick={() => setTabItem(false)}
          >
            BuiltIn
          </button>
        </li>
      </ul>
      <hr></hr>
        {tabItem ? (
          <PluginsOptional
            items={optional}
            userPlugins={userPlugins?.plugins}
            refreshData={refreshData}
          />
        ) : (
          <PluginsBuiltIn
            items2={builtin}
            userPlugins={userPlugins?.plugins}
            refreshData={refreshData}
          />
        )}
    </div>
  );
};

export default PluginsMain;
